<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1 class="mb-3">لیست آزمون های آزاد</h1>
          <b-row>
            <b-col cols="12">
              <b-table
                ref="refUserListTable"
                class="position-relative"
                :items="examsList"
                responsive
                :fields="myTableColumns"
                primary-key="id"
                show-empty
                bordered
                striped
                empty-text="موردی موجود نیست!"
              >
                <template #cell(createDate)="data">
                  {{
                    new Date(data.item.createDate).toLocaleDateString("fa-IR")
                  }}
                </template>
                <template #cell(actions)="data">
                  <div class="d-flex align-items-center" style="gap: 2rem">
                    <b-link
                      :to="`/apps/exams/public/${data.item.publicExamId}`"
                    >
                      <feather-icon
                        size="20"
                        icon="EditIcon"
                        class="text-primary"
                      />
                    </b-link>
                    <b-button
                      class="p-0"
                      variant="transparent"
                      @click="renderDeleteModal(data.item)"
                    >
                      <feather-icon
                        size="20"
                        icon="Trash2Icon"
                        class="text-danger"
                      />
                    </b-button>
                  </div>
                </template>
              </b-table>
            </b-col>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end py-2"
            >
              <b-pagination
                v-model="pageNumber"
                :total-rows="totalCount"
                :per-page="count"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    style="transform: rotate(180deg)"
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <!-- Faq Delete Modal Start -->
    <b-modal
      ok-variant="danger"
      title="حذف آزمون آزاد"
      id="delete-modal"
      centered
      ok-title="بله"
      cancel-title="خیر"
      @ok="deleteAnExam"
    >
      <p>آیا از حذف آزمون آزاد اطمینان دارید؟</p>
    </b-modal>
    <!-- Faq Delete Modal End -->
  </b-overlay>
</template>
<script>
export default {
  mounted() {
    this.getAllExams();
  },
  watch: {
    pageNumber: {
      handler(val) {
        this.getAllExams();
      },
    },
  },
  data() {
    return {
      tempExamId: null,
      isLoading: false,
      examsList: null,
      count: 10,
      pageNumber: 1,
      totalCount: null,
      lessonId: null,
      creatorId: null,
      searchCommand: null,
      myTableColumns: [
        {
          key: "publicExamId",
          label: "شناسه آزمون",
        },
        {
          key: "title",
          label: "عنوان آزمون",
        },
        {
          key: "createDate",
          label: "تاریخ ایجاد",
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
    };
  },
  methods: {
    async getAllExams() {
      try {
        this.isLoading = true;
        let qParams = {
          count: this.count,
          pageNumber: this.pageNumber,
        };
        if (this.searchCommand) {
          qParams["searchCommand"] = this.searchCommand;
        }
        if (this.lessonId) {
          qParams["lessonId"] = this.lessonId;
        }
        if (this.creatorId) {
          qParams["creatorId"] = this.creatorId;
        }
        let _this = this;
        let getAllPublicExams = new GetAllPublicExams(_this);
        getAllPublicExams.setRequestParam(qParams);
        await getAllPublicExams.fetch((response) => {
          if (response.isSuccess) {
            _this.examsList = response.data.publicExams;
            _this.totalCount = response.data.publicExamsCount;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    renderDeleteModal(publicExam) {
      this.tempExamId = publicExam.publicExamId;
      this.$bvModal.show("delete-modal");
    },
    async deleteAnExam() {
      try {
        this.isLoading = true;
        let _this = this;
        let deleteAPublicExam = new DeleteAPublicExam(_this);
        deleteAPublicExam.setRequestParam({ id: _this.tempExamId });
        await deleteAPublicExam.fetch((response) => {
          if (response.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "آزمون با موفقیت حذف شد",
                icon: "Trash2Icon",
                variant: "danger",
              },
            });
            _this.getAllExams();
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BModal,
    BCard,
    BRow,
    BCol,
    BFormFile,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
  },
};
import {
  BModal,
  BCard,
  BRow,
  BCol,
  BFormFile,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
import { GetAllPublicExams, DeleteAPublicExam } from "@/libs/Api/PublicExam";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
</script>
